import { render, staticRenderFns } from "./SpeedboatEmailModal.vue?vue&type=template&id=6d06f856"
import script from "./SpeedboatEmailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeedboatEmailModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports